import React, { useEffect, useState } from "react";
import { API } from "aws-amplify";
import { unsubscribe } from "../graphql/mutations";
import "../App.css";

const Unsubscribe = () => {
  const [subscribed, setSubscribed] = useState(true);
  const [sourceApp, setSourceApp] = useState("");
  const [invalidParams, setInvalidParams] = useState(false);
  useEffect(() => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    setSourceApp(params.sourceApp);
    //setEmail(params.email)
    //setEmailHash(params.tid)
    console.log(
      "params",
      {
        functionName: "getUnsubscribe",
        emailHash: params.tid,
        email: params.email,
        sourceEmail: params.sourceApp,
      },
      "function",
      unsubscribe
    );

    API.graphql({
      query: unsubscribe,
      variables: {
        functionName: "getUnsubscribe",
        emailHash: params.tid,
        email: params.email,
        sourceEmail: params.sourceApp,
      },
      authMode: "AWS_IAM",
    })
      .then((data) => {
        console.log("response", JSON.parse(data.data.unsubscribe));
        const resp = JSON.parse(data.data.unsubscribe);
        if (resp.body.isDeleted === false) setSubscribed(false);
        else setSubscribed(true);
      })
      .catch((error) => {
        console.log("error", error);
        setInvalidParams(true);
      });
  }, []);

  const unsubscribe2 = async () => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    API.graphql({
      query: unsubscribe,
      variables: {
        functionName: "addUnsubscribe",
        emailHash: params.tid,
        email: params.email,
        sourceEmail: params.sourceApp,
      },
      authMode: "AWS_IAM",
    })
      .then((data) => {
        console.log("response", JSON.parse(data.data.unsubscribe));
        setSubscribed(false);
      })
      .catch((error) => console.log("error", error));
  };

  const subscribe = async () => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    API.graphql({
      query: unsubscribe,
      variables: {
        functionName: "removeUnsubscribe",
        emailHash: params.tid,
        email: params.email,
        sourceEmail: params.sourceApp,
      },
      authMode: "AWS_IAM",
    })
      .then((data) => {
        console.log("response", JSON.parse(data.data.unsubscribe));
        setSubscribed(true);
      })
      .catch((error) => console.log("error", error));
  };
  return invalidParams ? (
    <div>invalid parametters</div>
  ) : subscribed ? (
    <div>
      You are currently subscribed to receive emails from {sourceApp}.<br />
      <a onClick={unsubscribe2}> click to unsubscribe</a>
    </div>
  ) : (
    <div>
      You are currently unsubscribed to receive emails from {sourceApp}.
      <div>
        <a onClick={subscribe}> click to subscribe</a>
      </div>
    </div>
  );
};
export default Unsubscribe;
